function useTagStyles(_ref) {
  var size = _ref.size,
      allowLineBreak = _ref.allowLineBreak;
  var tagStyleProps = {
    alignItems: 'items-center',
    backgroundColor: 'bg-gray-200',
    borderRadius: 'rounded'
  };
  var tagContentStyleProps = {
    padding: 'px-1',
    outline: 'outline-none'
  };
  var closeButtonStyleProps = {
    backgroundColor: 'bg-gray-300',
    borderRadius: 'rounded',
    iconSize: 'sm'
  };

  if (allowLineBreak) {
    tagStyleProps.overflow = 'overflow-hidden';
    tagContentStyleProps.overflow = 'overflow-hidden';
    tagContentStyleProps.whitespace = 'whitespace-no-wrap';
  } else {
    tagContentStyleProps.minWidth = 'min-w-max-content';
  }

  switch (size) {
    case 'sm':
      tagStyleProps.margin = ['mx-1', 'my-0.5'];
      tagContentStyleProps.fontSize = 'text-xs';
      tagContentStyleProps.lineHeight = 'leading-5';
      closeButtonStyleProps.height = 'h-5';
      closeButtonStyleProps.padding = 'p-1';
      break;

    case 'md':
    default:
      tagStyleProps.margin = 'm-1';
      tagContentStyleProps.fontSize = 'text-sm';
      tagContentStyleProps.lineHeight = 'leading-6';
      closeButtonStyleProps.height = 'h-6';
      closeButtonStyleProps.padding = 'p-1.5';
      break;
  }

  return {
    tagStyleProps: tagStyleProps,
    tagContentStyleProps: tagContentStyleProps,
    closeButtonStyleProps: closeButtonStyleProps
  };
}

export default useTagStyles;
//# sourceMappingURL=styles.esm.js.map
